import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqData = [
    { q: "Do you only serve Japanese clients?", a: "While we specialize in supporting Japanese individuals and companies, our services are available to all clients seeking reliable business and mobility solutions in India." },
    { q: "In which cities do you provide services?", a: "We offer services across major cities and industrial regions throughout India, ensuring reliable support wherever your business operates." },
    { q: "What types of vehicles are available for car rental?", a: "We provide a wide range of well-maintained vehicles including sedans, SUVs, and executive cars with professional drivers for corporate travel." },
    { q: "Do you provide long-term car rental options?", a: "Yes, we offer flexible daily, monthly, and long-term rental plans tailored to corporate and individual requirements." },
    { q: "Can you help with office or residential property leasing?", a: "Yes, we assist with verified commercial and residential properties, including offices, factories, and executive housing." },
    { q: "Do you assist with complete business setup in India?", a: "Absolutely. We provide end-to-end support including company registration, documentation, government approvals, and operational setup." },
    { q: "How can I get a quotation for your services?", a: "You can contact us via phone, email, or WhatsApp to discuss your requirements and receive a customized quotation." },
    { q: "How can we contact your team?", a: "You can reach us through phone, WhatsApp, or email. Our team will be happy to assist you with your requirements." }
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    return (
        <section
            className="py-24 bg-cover bg-center bg-fixed relative"
            style={{ backgroundImage: "url('/city-background.jpg')" }}
        >
            {/* Overlay */}
            <div className="absolute inset-0 bg-white/80"></div>

            <div className="relative max-w-4xl mx-auto px-6">
                <h2 className="text-5xl font-extrabold text-gray-900 text-center mb-16">Frequently Asked Questions</h2>

                <div className="bg-white/60 backdrop-blur-md shadow-2xl border border-white/50 rounded-lg overflow-hidden">
                    {faqData.map((item, index) => (
                        <div key={index} className="border-b border-gray-200 last:border-b-0">
                            <button
                                className="w-full py-6 px-8 flex justify-between items-center text-left text-lg font-bold text-gray-900 hover:bg-black/5 transition"
                                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                            >
                                <span>{item.q}</span>
                                <span className="text-xl">{activeIndex === index ? '−' : '+'}</span>
                            </button>

                            <AnimatePresence>
                                {activeIndex === index && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        className="overflow-hidden bg-white/40"
                                    >
                                        <p className="py-6 px-8 text-gray-700 leading-relaxed">{item.a}</p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;